import { CateringAddonOption } from '../models/cateringAddonGroup.model';
import { CartItem, CartItemAddonSelection } from '../models/cartItem.model';

export function isLinkedAddonOption(
  option: Pick<CateringAddonOption, 'linkedCateringProductId'>
): boolean {
  return !!option.linkedCateringProductId?.trim();
}

export function getAddonOptionUnitAmountInOre(
  option: CateringAddonOption
): number {
  return (Number(option.price) || 0) * 100;
}

/** Each selected addon is charged per product quantity (e.g. topping on every cake). */
export function getAddonOptionLineAmount(
  option: CateringAddonOption,
  quantity: number
): number {
  const qty = quantity || 1;
  return getAddonOptionUnitAmountInOre(option) * qty;
}

export function getAddonOptionUnitDisplayAmount(
  option: CateringAddonOption
): number {
  return Number(option.price) || 0;
}

export function getAddonOptionDisplayAmount(
  option: CateringAddonOption,
  quantity: number
): number {
  const qty = quantity || 1;
  return getAddonOptionUnitDisplayAmount(option) * qty;
}

export function getAddonSelectionsTotal(
  selectedAddons: CartItemAddonSelection[] | undefined,
  quantity: number
): number {
  if (!selectedAddons?.length) return 0;
  const qty = quantity || 1;
  return selectedAddons.reduce(
    (sum, { option }) => sum + getAddonOptionLineAmount(option, qty),
    0
  );
}

export function getCartItemLineTotal(item: CartItem): number {
  const quantity = item.quantity || 0;
  const base = (item.product?.cost || 0) * quantity;
  return base + getAddonSelectionsTotal(item.selectedAddons, quantity);
}

export function getAddonSelectionSignature(
  selectedAddons?: CartItemAddonSelection[]
): string {
  if (!selectedAddons?.length) return '';
  return [...selectedAddons]
    .map((a) => `${a.groupKey}:${a.option.id}`)
    .sort()
    .join('|');
}

export function normalizeCartItemAddons(
  selectedAddons?: CartItemAddonSelection[]
): CartItemAddonSelection[] | undefined {
  if (!selectedAddons?.length) return undefined;
  return selectedAddons.map(({ groupKey, option }) => ({
    groupKey,
    option: { ...option },
  }));
}
